module.exports = __webpack_public_path__ + "static/media/project4.c1b31190.png";